import {apolloClient} from '@/apollo'
import {
    ADD_ITEM_ORDER_DISCOUNT,
    ADD_ITEM_TO_ORDER,
    ADD_ITEM_TO_SAMPLE_ORDER,
    ADD_NEW_ORDER,
    ADD_NEW_SAMPLE_ORDER, ADD_ORDER_DISCOUNT, ADD_SURCHARGE_TO_ORDER,
    CHANGE_ORDER_DELIVERY_DATE,
    CHANGE_ORDER_PAYMENT_STATUS,
    CHANGE_ORDER_STATUS,
    CHANGE_SAMPLE_ORDER_STATUS,
    CHECK_ORDER_AVAILABLE_TIMEZONES,
    CHECK_SINGLE_ORDER_VALIDITY, CREATE_CREDIT_NOTE,
    CREATE_ORDER_DEPOSIT,
    DELETE_ITEM_FROM_ORDER,
    DELETE_ITEM_FROM_SAMPLE_ORDER,
    DELETE_ITEM_ORDER_DISCOUNT,
    DELETE_ORDER_DISCOUNT, DELETE_SURCHARGE_FROM_ORDER, SEND_WAREHOUSE_EMAIL,
    UPDATE_ITEM_ORDER_DISCOUNT, UPDATE_ORDER_DISCOUNT,
    UPDATE_ORDER_ITEM,
    UPDATE_SAMPLE_ORDER_ITEM
} from "@/gql/orders";

export const state = {
    loading: false,
    errors: [],
}
export const getters = {
    ordersLoading: state => state.loading,
    ordersErrors: state => state.errors
}
export const actions = {

    async addNewCustomerOrder({commit}, orderData){
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try{
            let {data: {createOrder}} = await apolloClient.mutate({
                mutation: ADD_NEW_ORDER,
                variables: orderData
            })
            return createOrder.order
        }catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        }finally {
            commit('LOADING_FALSE')
        }
    },

    async addItemToOrder({commit}, orderData){
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try{
            let {data: {orderItem}} = await apolloClient.mutate({
                mutation: ADD_ITEM_TO_ORDER,
                variables: orderData
            })
            return orderItem.orderLineItem
        }catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        }finally {
            commit('LOADING_FALSE')
        }
    },

    async updateOrderItem({commit}, orderData){
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try{
            let {data: {orderItem}} = await apolloClient.mutate({
                mutation: UPDATE_ORDER_ITEM,
                variables: orderData
            })
            return orderItem.orderLineItem
        }catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        }finally {
            commit('LOADING_FALSE')
        }
    },

    async deleteItemFromOrder({commit}, orderData){
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try{
            let {data: {deleteOrderItem}} = await apolloClient.mutate({
                mutation: DELETE_ITEM_FROM_ORDER,
                variables: orderData
            })
            return deleteOrderItem
        }catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        }finally {
            commit('LOADING_FALSE')
        }
    },

    async checkSingleOrderValidity({commit}, orderId){
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try{
            let {data: {orderProcessingValidity}} = await apolloClient.query({
                query: CHECK_SINGLE_ORDER_VALIDITY,
                variables: orderId
            })
            return orderProcessingValidity
        }catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        }finally {
            commit('LOADING_FALSE')
        }
    },

    async changeOrderStatus({commit}, orderData){
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try{
            let {data: {changeOrderStatus}} = await apolloClient.mutate({
                mutation: CHANGE_ORDER_STATUS,
                variables: orderData
            })
            return changeOrderStatus
        }catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        }finally {
            commit('LOADING_FALSE')
        }
    },

    async addSurchargeToOrder({commit}, orderData){
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try{
            let {data: {setSurcharge}} = await apolloClient.mutate({
                mutation: ADD_SURCHARGE_TO_ORDER,
                variables: orderData
            })
            return setSurcharge
        }catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        }finally {
            commit('LOADING_FALSE')
        }
    },

    async deleteSurchargeFromOrder({commit}, orderData){
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try{
            let {data: {deleteSurcharge}} = await apolloClient.mutate({
                mutation: DELETE_SURCHARGE_FROM_ORDER,
                variables: orderData
            })
            return deleteSurcharge
        }catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        }finally {
            commit('LOADING_FALSE')
        }
    },

    async changeOrderPaymentStatus({commit}, orderData){
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try{
            let {data: {changeOrderPaymentStatus}} = await apolloClient.mutate({
                mutation: CHANGE_ORDER_PAYMENT_STATUS,
                variables: orderData
            })
            return changeOrderPaymentStatus
        }catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        }finally {
            commit('LOADING_FALSE')
        }
    },

    async changeOrderPaymentDeposit({commit}, orderData){
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try{
            let {data: {depositOrderPayment}} = await apolloClient.mutate({
                mutation: CREATE_ORDER_DEPOSIT,
                variables: orderData
            })
            return depositOrderPayment
        }catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        }finally {
            commit('LOADING_FALSE')
        }
    },
    async sendWarehouseEmail({commit}){
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try{
            await apolloClient.cache.reset()
            let {data: {triggerWarehouseEmail}} = await apolloClient.query({
                query: SEND_WAREHOUSE_EMAIL
            })
            return triggerWarehouseEmail
        }catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        }finally {
            commit('LOADING_FALSE')
        }
    },

    async addNewSampleOrder({commit}, orderData){
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try{
            let {data: {createSampleOrder}} = await apolloClient.mutate({
                mutation: ADD_NEW_SAMPLE_ORDER,
                variables: orderData
            })
            return createSampleOrder.sampleOrder
        }catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        }finally {
            commit('LOADING_FALSE')
        }
    },

    async addItemToSampleOrder({commit}, orderData){
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try{
            let {data: {sampleOrderItem}} = await apolloClient.mutate({
                mutation: ADD_ITEM_TO_SAMPLE_ORDER,
                variables: orderData
            })
            return sampleOrderItem
        }catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        }finally {
            commit('LOADING_FALSE')
        }
    },

    async updateSampleOrderItem({commit}, orderData){
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try{
            let {data: {sampleOrderItem}} = await apolloClient.mutate({
                mutation: UPDATE_SAMPLE_ORDER_ITEM,
                variables: orderData
            })
            return sampleOrderItem
        }catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        }finally {
            commit('LOADING_FALSE')
        }
    },

    async deleteItemFromSampleOrder({commit}, orderData){
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try{
            let {data: {deleteSampleOrderItem}} = await apolloClient.mutate({
                mutation: DELETE_ITEM_FROM_SAMPLE_ORDER,
                variables: orderData
            })
            return deleteSampleOrderItem
        }catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        }finally {
            commit('LOADING_FALSE')
        }
    },

    async changeSampleOrderStatus({commit}, orderData){
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try{
            let {data: {changeSampleOrderStatus}} = await apolloClient.mutate({
                mutation: CHANGE_SAMPLE_ORDER_STATUS,
                variables: orderData
            })
            return changeSampleOrderStatus
        }catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        }finally {
            commit('LOADING_FALSE')
        }
    },

    async addNewCreditOrder({commit}, orderData){
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try{
            let {data: {createCreditNote}} = await apolloClient.mutate({
                mutation: CREATE_CREDIT_NOTE,
                variables: orderData
            })
            return createCreditNote.creditNote
        }catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        }finally {
            commit('LOADING_FALSE')
        }
    },

    async changeOrderDeliveryDate({commit}, orderData){
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try{
            let {data: {changeDeliveryDate}} = await apolloClient.mutate({
                mutation: CHANGE_ORDER_DELIVERY_DATE,
                variables: orderData
            })
            return changeDeliveryDate
        }catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        }finally {
            commit('LOADING_FALSE')
        }
    },

    async checkAvailableTimezone({commit}, orderData){
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try{
            let {data: {availableTimezones}} = await apolloClient.query({
                query: CHECK_ORDER_AVAILABLE_TIMEZONES,
                variables: orderData
            })
            return availableTimezones
        }catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        }finally {
            commit('LOADING_FALSE')
        }
    },

    async addOrderItemDiscount({commit}, orderData){
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try{
            let {data: {itemDiscount}} = await apolloClient.mutate({
                mutation: ADD_ITEM_ORDER_DISCOUNT,
                variables: orderData
            })
            return itemDiscount
        }catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        }finally {
            commit('LOADING_FALSE')
        }
    },

    async updateOrderItemDiscount({commit}, orderData){
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try{
            let {data: {itemDiscount}} = await apolloClient.mutate({
                mutation: UPDATE_ITEM_ORDER_DISCOUNT,
                variables: orderData
            })
            return itemDiscount
        }catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        }finally {
            commit('LOADING_FALSE')
        }
    },

    async deleteOrderItemDiscount({commit}, orderData){
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try{
            let {data: {deleteItemDiscount}} = await apolloClient.mutate({
                mutation: DELETE_ITEM_ORDER_DISCOUNT,
                variables: orderData
            })
            return deleteItemDiscount
        }catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        }finally {
            commit('LOADING_FALSE')
        }
    },

    async addOrderDiscount({commit}, orderData){
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try{
            let {data: {orderDiscount}} = await apolloClient.mutate({
                mutation: ADD_ORDER_DISCOUNT,
                variables: orderData
            })
            return orderDiscount
        }catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        }finally {
            commit('LOADING_FALSE')
        }
    },

    async updateOrderDiscount({commit}, orderData){
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try{
            let {data: {orderDiscount}} = await apolloClient.mutate({
                mutation: UPDATE_ORDER_DISCOUNT,
                variables: orderData
            })
            return orderDiscount
        }catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        }finally {
            commit('LOADING_FALSE')
        }
    },

    async deleteOrderDiscount({commit}, orderData){
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try{
            let {data: {deleteOrderDiscount}} = await apolloClient.mutate({
                mutation: DELETE_ORDER_DISCOUNT,
                variables: orderData
            })
            return deleteOrderDiscount
        }catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        }finally {
            commit('LOADING_FALSE')
        }
    },
}
export const mutations = {
    LOADING_TRUE(state){
        state.loading = true
    },
    LOADING_FALSE(state){
        state.loading = false
    },
    SET_ERRORS(state, payload){
        state.errors = payload
    },
    REMOVE_ERRORS(state){
        state.errors = []
    }
}


